import { memo } from 'react';
import { ForeignState } from 'mutation/view-models/registration-citizenship';
import { Grid, useEventCallback } from '@mui/material';
import ForeignStateList, { ForeignStateVM } from 'shell/components/shared/foreign-state-list';
import PmiTextField from 'shell/components/shared/text-field';

interface OpenLegisProps {
  values?: ForeignState;
  onChange: (key: keyof ForeignState, value: ForeignState[keyof ForeignState]) => void;
  disabled?: boolean;
  required?: boolean;
}

const ForeignComponent = ({
  onChange,
  values,
  disabled,
  required,
}: OpenLegisProps): React.ReactElement => {
  const onChangeForeignStateList = useEventCallback((state: ForeignStateVM | null | undefined) => {
    onChange('foreignState', state);
  });

  return (
    <Grid
      item
      container
      spacing={0}
      columnSpacing={{ xs: 0, md: 1 }}
      rowSpacing={{ xs: 1, md: 0 }}
      xs={12}
    >
      <Grid item xs={12} md={6}>
        <ForeignStateList
          value={values?.foreignState || null}
          onChange={onChangeForeignStateList}
          label="Stato estero"
          id="foreignState"
          disabled={disabled}
          required={required}
        />
      </Grid>
      <Grid item xs={12} md={3}>
        <PmiTextField
          aria-label="Provincia o Contea"
          label="Provincia/Contea"
          id="foreignProvince"
          name="foreignProvince"
          fullWidth
          type="text"
          variant="outlined"
          value={values?.foreignState?.province || ''}
          disabled
        />
      </Grid>
    </Grid>
  );
};

ForeignComponent.displayName = 'Form Accordion Registration Citizenship - to DPR component Foreign';

const Foreign = memo(ForeignComponent);

export default Foreign;
